module.exports = __webpack_public_path__ + "img/ambulancia_down.2138e459.svg";